import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export const useEmailValidation = () =>
  useMutation(async (payload) => {
    const { data } = await axios.post('/api/auth/member/validate-email', payload);
    return data;
  });
